import loadMixpanelSnippet from 'mixpanel';

export default {
  load(token, debug, onLoaded, libUrl, apiHost) {
    loadMixpanelSnippet({ libUrl });
    window.mixpanel.init(token, {
      debug,
      loaded: onLoaded,
      ...(apiHost && { api_host: apiHost }),
    });
  },

  analyticsReady(callback) {
    callback();
  },

  getAnalytics() {
    return window.mixpanel;
  },

  trackEvent(name, properties, options, callback) {
    if (!window.mixpanel) return;
    window.mixpanel.track(name, properties, callback);
  },

  getDistinctId() {
    /* eslint-disable-next-line no-underscore-dangle */
    if (window.mixpanel && window.mixpanel.__loaded) {
      return window.mixpanel.get_distinct_id();
    }

    console.warn('Analytics ➞ User Distinct Id not available');
    return '';
  },

  identifyUser(userId, traits, options, callback) {
    if (!window.mixpanel) return;
    window.mixpanel.identify(userId);
    window.mixpanel.people.set(traits, callback);
  },

  userAlias(newId, previousId, traits, callback) {
    if (!window.mixpanel) return;
    window.mixpanel.alias(newId, previousId);
    window.mixpanel.people.set(traits, callback);
  },

  setUserProperties(traits, callback, setOnce) {
    if (!window.mixpanel) return;
    if (setOnce) {
      window.mixpanel.people.set_once(traits, callback);
    } else {
      window.mixpanel.people.set(traits, callback);
    }
  },

  resetUser() {
    if (!window.mixpanel) return;
    window.mixpanel.reset();
  },
};



// WEBPACK FOOTER //
// ./tracker.mp.js